export { default as ComboSelect } from './ComboSelect/ComboSelect.svelte';
export { default as Modal } from './Modal.svelte';
export { default as GlobalHazardForm } from './GlobalHazard/GlobalHazardForm.svelte';
export { default as GlobalHazardFormV2 } from './GlobalHazard/GlobalHazardFormV2.svelte';
export { default as BranchConfigurations } from './GlobalHazard/BranchConfigurations.svelte';
export { default as GlobalToolList } from './GlobalTool/GlobalToolList.svelte';
export { default as ToolForm } from './GlobalTool/ToolForm.svelte';
export { default as RichTextEditor } from './RichTextEditor.svelte';
export { default as FocusQuestionInput } from './FocusQuestionInput.svelte';
export { default as Stepper } from './Stepper/Stepper.svelte';
export { default as StepperNavigator } from './Stepper/StepperNavigator.svelte';
export { default as DuplicateCheckTextInput } from './DuplicateCheckTextInput.svelte';
export { default as BranchHazardControlForm } from './BranchHazard/BranchHazardControlForm.svelte';
export { default as ExpireBranchHazardControlForm } from './BranchHazard/ExpireBranchHazardControlForm.svelte';
export { default as Button } from './Button.svelte';
export { default as DraftSequenceControlConfigurationForm } from './BranchHazard/DraftSequenceControlConfigurationForm.svelte';
export { default as CheckBox } from './CheckBox.svelte';
export { default as ModalBS3 } from './ModalBS3.svelte';
export { default as ConfirmationModal } from './ConfirmationModal.svelte';
export { default as HazardControlTable } from './BranchHazard/HazardControlTable.svelte';
export { default as GlobalControlForm } from './GlobalHazard/GlobalControlForm.svelte';
export { default as SearchEmailGroupForm } from './EmailGroup/SearchEmailGroupForm.svelte';
export { default as EditEmailGroupForm } from './EmailGroup/EditEmailGroupForm.svelte';
export { default as EmailGroupUserList } from './EmailGroup/EmailGroupUserList.svelte';
export { default as ActivitySettingsEmailRecipients } from './EmailGroup/ActivitySettingsEmailRecipients.svelte';
export { default as Workspaces } from './Workspaces/Workspaces.svelte';
export { default as DataTable } from './DataGrid/DataTable.svelte';
export { default as DataList } from './DataGrid/DataList.svelte';
export { default as TabView } from './TabView/TabView.svelte';
export { default as WorkflowManagement } from './Activity/ActivitySettings/WorkflowManagement.svelte';
export { default as InstructionsPDFDownloadsTable } from './Activity/InstructionsPDFTemplate/InstructionsPDFDownloadsTable.svelte';
export { default as TaskListConfigurationTable } from './Activity/ActivityVersion/TaskListConfigurationTable.svelte';
export { default as OperationMappingForm } from './Activity/ActivityVersion/OperationMappingForm.svelte';
export { default as KeyPointsEditor } from './Element/KeyPointsEditor.svelte';
export { default as ElementEditor } from './Element/ElementEditor.svelte';
export { default as StandaloneElementEditor } from './Element/StandaloneElementEditor.svelte';
export { default as ReferenceDocumentEditor } from './Element/ReferenceDocumentEditor.svelte';
export { default as CompetenciesAutocompleteWidget } from './Competencies/CompetenciesAutocompleteWidget.svelte';
export { default as CompetenciesTable } from './Competencies/CompetenciesTable.svelte';
export { default as ElementTags } from './Element/Tag/ElementTags.svelte';
export { default as ElementCompetencies } from './Element/Competency/ElementCompetencies.svelte';
export { default as ElementReportingGroups } from './Element/ReportingGroup/ElementReportingGroups.svelte';
export { default as ActivityVersionSummaryDiffView } from './Diff/ActivityVersionSummaryDiffView.svelte';
export { default as HomePage } from './DashBoard/HomePage.svelte';
export { default as ApprovalDialog } from './Diff/ApprovalDialog.svelte';
export { default as ApprovalButtons } from './Diff/ApprovalButtons.svelte';
export { default as RequestDialog } from './Diff/RequestDialog.svelte';
export { default as RegisteredDevicesToInstances } from './MobileDevice/RegisteredDevicesToInstances.svelte';
export { default as InstancesOnDeviceSummary } from './MobileDevice/InstancesOnDeviceSummary.svelte';
export { default as TimeConfirmations } from './TimeConfirmations/TimeConfirmations.svelte';
export { default as LoginView } from './Login/LoginView.svelte';
export { default as IssueListPage } from './Improvement/IssueListPage.svelte';
export { default as IssueDetails } from './Improvement/IssueDetails.svelte';
export { default as ReferenceDocumentForm } from './ReferenceDocument/ReferenceDocumentForm.svelte';
export { default as ActivityItems } from './ActivityItems/ActivityItems.svelte';
export { default as ContextualFieldLink } from './ContextualFieldLink.svelte';
export { default as CreateTaskListActivityStepper } from './Activity/CreateTaskListActivity/CreateTaskListActivityStepper.svelte';
export { default as D2ConfigurationAdmin } from './Administration/D2ConfigurationAdmin.svelte';

export { default as HmrDisplay } from './HmrDisplay.svelte';

const withHmr = (Component, config) => {
  const component = new Component(config);
  if (import.meta.hot) {
    import.meta.hot.dispose(() => {
      component.$destroy();
    });
    import.meta.hot.accept();
    console.log('Enabled HMR');
  }
  return component;
};

const warn = console.warn;
console.warn = (...args) => {
  const msg = args?.length && args[0];
  if (msg.includes('was created with unknown prop')) {
    return;
  }
  return warn(...args);
};

export { withHmr };
